import Image from "next/image"
import { blobMediaUrl } from "@/lib/blob-url"

/** 27px circular tab icon matching the dark pill on /membership + homepage.
 *  Shared by the /pricing tab bar and the how-it-works pricing tabs so the
 *  membership tab looks identical on both. */
export function MembershipTabIcon() {
  return (
    <span className="relative flex size-[27px] shrink-0 items-center justify-center overflow-hidden rounded-full">
      {/* See note in components/ui/new-membership-pill.tsx — using next/image
       *  so Vercel's optimizer serves a sized WebP (raw PNG is 6.6MB). */}
      <Image
        src={blobMediaUrl("/images/membership/pill-icon-bg.png")}
        alt=""
        width={134}
        height={75}
        aria-hidden="true"
        className="pointer-events-none absolute max-w-none"
        style={{ left: "-8.02px", top: "-22.86px" }}
      />
      <svg
        width="14"
        height="15"
        viewBox="0 0 15 16"
        fill="none"
        aria-hidden="true"
        className="relative"
      >
        <path
          d="M11.3742 0H0V1.99316L11.2938 1.71601C12.3158 1.69133 13.1522 2.51707 13.1311 3.53073L12.8861 15.7934H14.8593V3.4586C14.8593 1.54897 13.2976 0 11.3723 0H11.3742Z"
          fill="white"
        />
        <path
          d="M9.37226 4.30513L0 14.3525L1.42584 15.8028L10.8517 5.66047C11.2325 5.25045 11.2019 4.61264 10.7828 4.24059C10.3732 3.87612 9.74546 3.9046 9.37226 4.30513Z"
          fill="white"
        />
      </svg>
    </span>
  )
}
